__turbopack_context__.v({
  "AudioIconBars": "AudioIconBars-module-scss-module__WE22rW__AudioIconBars",
  "Bar": "AudioIconBars-module-scss-module__WE22rW__Bar",
  "up-down": "AudioIconBars-module-scss-module__WE22rW__up-down",
});
